export default {
    getHeaderFieldsEprofileLezartProblemak: state => state.headerFieldsEprofileLezartProblemak,
    getFormActionsEprofileLezartProblemak: state => state.formActionsEprofileLezartProblemak,
    getActionsEprofileLezartProblemak: state => state.actionsEprofileLezartProblemak,
    getRowActionsEprofileLezartProblemak: state => state.rowActionsEprofileLezartProblemak,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileLezartProblemak: state => state.formIsOpen,
    isGridOpenEprofileLezartProblemak: state => state.gridIsOpen
}
